import { render } from "./PayslipReadonlyField.vue?vue&type=template&id=a940d55a&scoped=true"
import script from "./PayslipReadonlyField.vue?vue&type=script&lang=js"
export * from "./PayslipReadonlyField.vue?vue&type=script&lang=js"

import "./PayslipReadonlyField.vue?vue&type=style&index=0&id=a940d55a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a940d55a"]])

export default __exports__